<template>
  <div>
    <!-- <div class="mdl-button mdl-button accent" @click="showTime">Show time</div> -->
    <div v-if="agenda.UnidadeLuandre !== undefined " id="boxAgenda" class="container">
    <h3> Agenda de Atendimento <span class="label label-warning">{{ this.unidadeNome(filial) }}</span></h3>
    <div class="text-left">
      <div class="row">
            <div class="form-group  col-lg-6">
            <label for="DataAgenda" v-show="isHabilitado" class="col-lg-6" style="margin-top: 7px;">Agenda do Dia: </label>
            <label for="DataAgenda" v-show="!isHabilitado" class="col-lg-6" style="margin-top: 7px;">Atualizando... </label>
                <div class="input-group">
                    <div class="input-group-addon">
                    <i class="fa fa-calendar" aria-hidden="true" v-show="isHabilitado"></i>
                    <i class="fa fa-circle-o-notch fa-spin" v-show="!isHabilitado"></i>
                    </div>
                        <input type="date" class="form-control " id="DataAgenda" v-model="diaAtual"  @keyup.enter ="carregarAgenda" style="font-size: 19px;" />
                    </div>
                 <!-- <small class="col-lg-5 " style="margin-left:160px"> <i>Escolha a data e tecle "Enter"</i> </small>  -->
            </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6">
            <label class="col-lg-6" >Histórico de agendamento do candidato: </label>
            <div class="input-group">
              <input type="text" v-mask="'###.###.###-##'" class="form-control" placeholder="Digite o CPF" @keyup.enter="abreModalHistoricoCandidato" v-model="cpfHistorico" >
              <span class="input-group-btn">
                  <button class="btn btn-primary" type="button" @click="abreModalHistoricoCandidato">
                    <span>Pesquisar</span>
                  </button>
              </span>
            </div>
          </div>
        </div>
        <!-- <div class="row">
          <input type="text" placeholder="Pesquisar na Agenda" v-model="pesquisa" class="form-control">
        </div> -->
        </div>
        <div class="row">
            <div class="col-lg-12">
              <div v-if="agenda.QuantidadeAssessores == 0">
                <h2>  :: Não existe uma agenda configurada para esta unidade <br /> ou não há horários disponíveis para esse dia ::  </h2>
              </div>
              <div v-else>
                <table class="table table-responsive table-stripped  table-bordered" style="background:#fcfcfc">
                    <thead>
                        <tr>
                            <th style=" max-width: 100px !important; width: 100px;">Horário</th>
                            <th v-for="indice of agenda.QuantidadeAssessores" :key="indice" >
                              Assessor {{ indice }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for=" hora of agenda.Horarios " :key="hora">
                            <td class="td-horarios" v-if="!(((agenda.BloqueioAgendaInicio !== '00:00:00') && (agenda.BloqueioAgendaFim !== '00:00:00')) && (hora >= agenda.BloqueioAgendaInicio && hora < agenda.BloqueioAgendaFim))"> <a href="#" data-toggle="modal" @click="horarioSelecionado = hora; validaQtdeAssessor($event)"  > {{ hora.substr(0,5) }} </a> <br /><br /><br /> <a href="#" class="btn btn-primary" v-if="podeBloquear" @click.prevent="bloquearHorario(hora.substr(0,5))" style="font-size:13px"> Bloquear Horario </a>  </td>
                            <td class="td-horarios" v-else>   {{ hora.substr(0,5) }} <br/> <small class="label label-danger"> Horário <br /> Reservado </small> <br />  </td>
                            <td class="td-marcados" :rowspan="agendado.QtdeColetivo == null || agendado.QtdeColetivo < 5 ? (30 / agenda.IntervaloAtendimento) * 1 : agendado.QtdeColetivo >= 5  && agendado.QtdeColetivo < 10 ? (30 / agenda.IntervaloAtendimento) * 2 : agendado.QtdeColetivo >= 10 && agendado.QtdeColetivo < 15 ? (30 / agenda.IntervaloAtendimento) * 3 : agendado.QtdeColetivo >= 15 && agendado.QtdeColetivo < 20 ? (30 / agenda.IntervaloAtendimento) * 4 : (30 / agenda.IntervaloAtendimento) * 5" v-for="agendado of agenda.Agendamento" v-if="agendado.DataHorario.substr(11) == hora" :key="agendado">
                              <div v-if="agendado.Tipo == 3">
                                <span v-if="idUsuario == agendado.Usuario.Id">
                                  <a style="float:right; color:#d9534f " href="#" @click.prevent="excluirAgendamento(agendado.Id)" title="Excluir" ><i class="fa fa-window-close" aria-hidden="true"></i></a>
                                </span>
                                <p class="text-left"><strong>Bloqueado Por: </strong><small> {{ agendado.Usuario.Nome }}</small></p>
                                <strong class="strongBloqueado">BLOQUEADO</strong>
                                 <br />
                                <p class="text-left"><strong>Motivo: </strong> <br />{{agendado.Observacoes}}</p>
                              </div>
                              <div v-else>
                                <ul class="list-group">
                                  <li class="list-group-item text-left">
                                  <span v-if="idUsuario == agendado.Usuario.Id">
                                      <span v-if="agendado.Coletivo === true">
                                        <a class="btn-exclusao" href="#" @click.prevent="excluirAgendamentoColetivo(agendado)" title="Excluir" ><i class="fa fa-window-close" aria-hidden="true"></i></a>
                                      </span>
                                      <span v-else>
                                          <a class="btn-exclusao" href="#" @click.prevent="excluirAgendamento(agendado.Id)" title="Excluir" ><i class="fa fa-window-close" aria-hidden="true"></i></a>
                                      </span>
                                  </span>
                                    <strong>Objetivo: </strong>
                                    <small v-if="agendado.Tipo == 0" class="label label-info" style="cursor:pointer;" :title="agendado.Observacoes == null || agendado.Observacoes == '' ? 'Nenhuma observação' : agendado.Observacoes"> Admissão </small>
                                    <small v-if="agendado.Tipo == 1" class="label label-danger" style="cursor:pointer;" :title="agendado.Observacoes == null || agendado.Observacoes == '' ? 'Nenhuma observação' : agendado.Observacoes"> Rescisão </small>
                                    <small v-if="agendado.Tipo == 2" class="label label-default" style="cursor:pointer;" :title="agendado.Observacoes == null || agendado.Observacoes == '' ? 'Nenhuma observação' : agendado.Observacoes"> Outros </small>
                                    <br /> <strong>Agendado Por: </strong>
                                    <small> {{ agendado.Usuario.Nome }}</small>
                                  </li>
                                  <li class="list-group-item text-left">
                                    <strong v-if="agendado.Coletivo === true">
                                      Coletivo:
                                    </strong>
                                    <strong v-else>
                                      Candidato:
                                    </strong>
                                    <small v-if="agendado.Coletivo === true">
                                      {{ agendado.TextoColetivo }}

                                      <div v-if="agendado.CandidatosColetivo && agendado.CandidatosColetivo.length > 0" :title="agendado.CandidatosColetivo.join(', ').replace(/,(?!.*,)/gmi, ' e ')">
                                        <strong>Candidatos:</strong> {{ agendado.CandidatosColetivo.join(', ').replace(/,(?!.*,)/gmi, ' e ').substr(0, 120) }}
                                      </div>
                                    </small>
                                    <span v-else>
                                        <small :title="agendado.Candidato.Nome">{{ agendado.Candidato.Nome.substr(0, 30) }} <span v-if="agendado.Candidato.CPF != null"> <br /><strong>CPF: </strong> {{ agendado.Candidato.CPF }} </span>  <span v-if="agendado.FichaAprovacao != null"> <br /><strong>Ficha de Aprovacao: </strong> {{ agendado.FichaAprovacao.Id }} </span> </small>
                                    </span>
                                  </li>
                                  <li class="list-group-item text-left" v-if="agendado.Empresa.RazaoSocial != undefined">
                                    <strong>Empresa: </strong>
                                    <small :title="agendado.Empresa.RazaoSocial">
                                      {{ agendado.Empresa.RazaoSocial == undefined ? '' : agendado.Empresa.RazaoSocial.substr(0, 40)  }}
                                    </small>
                                  </li>
                                  <li class="list-group-item text-left" v-if="agendado.Observacoes != null && agendado.Observacoes != '' ">
                                    <strong>Obs.: </strong>
                                    <small :title="agendado.Observacoes">
                                      {{ agendado.Observacoes.substr(0, 114) }}
                                    </small>
                                  </li>
                                </ul>
                              </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                          <td style="background:#2d618e; min-height:10px; max-height:10px; font-size:5px;" :colspan="agenda.QuantidadeAssessores+1"> &nbsp; </td>
                        </tr>
                    </tfoot>
                </table>
              </div>
            </div>
        </div >
        <ModalAgendar v-on:atualizarAgenda="carregarAgenda" :dia="this.diaAtual" :hora="horarioSelecionado" :HoraAdmissao="agenda.FimAdmissao"/>
    </div>
    <div v-else class="container" >
        <h2> :: Não foi possível conectar-se ao servidor :: <br /><br /> :: Contate a área de Projetos ::</h2>
    </div>
    <div class="label label-warning atualizacaoAutomatica">
      Próxima atualização automática: {{ count }}
    </div>





    <ModalHistoricoCandidato ref="modalHistorico" />
    <ModalBloquearHorario v-on:atualizarAgenda="carregarAgenda" ref="modalBloquear" :QuantidadeAssessores="this.agenda.QuantidadeAssessores" />

  </div>
</template>
<script>
import ModalAgendar from './shared/modal/ModalAgendar.vue'
import ModalHistoricoCandidato from './shared/modal/HistoricoCandidato.vue'
import ModalBloquearHorario from './shared/modal/BloquearHorario.vue'
import moment from 'moment'
import 'vue-toast/dist/vue-toast.min.css'
export default{
  name: 'Agenda',
  methods: {
    validaQtdeAssessor: function (td) {
      if ((this.agenda.QuantidadeAssessores) <= $(td.currentTarget).parent().parent().children().length - 1) {
        alert('Horário indisponível.')
      } else {
        $('#modalAgendar').modal('show')
      }
    },
    bloquearHorario (hora) {
      $('#modalBloquearHorario').modal('show')
      this.$refs.modalBloquear.oDia = this.diaAtual
      this.$refs.modalBloquear.oHora = hora
    },
    abreModalHistoricoCandidato () {
      $('#modalHistoricoCandidato').modal('show')
      this.$refs.modalHistorico.pesquisar(this.cpfHistorico)
    },
    carregarAgenda () {
      this.count = 16
      this.isHabilitado = false
      this.$http.get('agenda?data=' + this.diaAtual + '&unidade=' + this.filial)
      .then(function (res) {
        this.isHabilitado = true
        this.agenda = res.body
      })
      .catch(function (err) {
        this.isHabilitado = true
        console.error(err)
      })
    },
    formatarData: function (d) { return moment(String(d)).format('DD/MM/YYYY') },
    excluirAgendamento: function (id) {
      if (confirm('Deseja realmente excluir esse agendamento?')) {
        this.$http.delete('agendamento/deletar?id=' + id + '&idUsuario=' + this.idUsuario)
        .then(function (res) {
          this.carregarAgenda()
        })
        .catch(function (err) {
          this.isHabilitado = true
          alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
          console.log(err)
        })
      }
    },
    excluirAgendamentoColetivo: function (agendamento) {
      if (confirm('Deseja realmente excluir esse agendamento?')) {
        this.$http.post('agendamento/deletar-coletivo', agendamento)
        .then(function (res) {
          this.carregarAgenda()
        })
        .catch(function (err) {
          this.isHabilitado = true
          alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
          console.log(err)
        })
      }
    },
    unidadeNome: function (id) {
      let escrito = ''
      switch (id) {
        case 0:
          escrito = 'Matriz'
          break
        case 1:
          escrito = 'ABC'
          break
        case 2:
          escrito = 'Alphaville'
          break
        case 4:
          escrito = 'Campinas'
          break
        case 5:
          escrito = 'Curitiba'
          break
        case 6:
          escrito = 'Faria Lima'
          break
        case 7:
          escrito = 'Guarulhos'
          break
        case 8:
          escrito = 'Jundiaí'
          break
        case 10:
          escrito = 'Rio de Janeiro'
          break
        case 11:
          escrito = 'Santo Amaro'
          break
        case 14:
          escrito = 'Recife'
          break
      }
      return escrito
    }
  },
  computed: {
    filteredData: function () {
      var filtro = this.pesquisa && this.pesquisa.toLowerCase()
      var data = this.agenda.Agendamento
      if (filtro) {
        data = data.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filtro) > -1
          })
        })
      }
      return data
    }
  },
  components: {
    ModalAgendar,
    ModalHistoricoCandidato,
    ModalBloquearHorario
  },
  created: function () {
    this.diaAtual = moment().format('YYYY-MM-DD')
    this.filial = localStorage.getItem('Unidade') == null ? 0 : parseInt(localStorage.getItem('Unidade'))
    this.idUsuario = JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
    this.podeBloquear = JSON.parse(localStorage.getItem('Usuario')).BotaoBotaoBloquearHorario === 'OK'
    this.carregarAgenda()
    setInterval(() => {
      this.carregarAgenda()
    }, 15000)
    setInterval(() => this.count--, 1000)
  },
  props: ['UnidadeLuandre'],
  data () {
    return {
      diaAtual: '',
      filtro: [],
      horarioSelecionado: '',
      agenda: {},
      countColetivo: 0,
      filial: '',
      contadorIndice: 1,
      renderizados: [],
      isHabilitado: true,
      idUsuario: '',
      pesquisa: '',
      count: 15,
      cpfHistorico: '',
      horaBloquear: '',
      podeBloquear: true
    }
  }
}

</script>
<style scoped>
#boxAgenda{
    width:100%;
}
table{
    width:100% !important;
    overflow:hidden;
}
thead{
    width:100% !important;
}
tbody{
    width:100% !important;
}
th{
    text-align:center;
    padding: 8px 0;
    background: #2d618e;
    color: #fff !important;
    font-size: 15px;
    font-weight: bold;
}
tbody tr {
    border:1px solid #333;
}
hr {

    border-top: 1px solid #fff !important;
}
tbody td {
    padding: 2px;
    background:#bbb;
    border:1px solid #fff !important;
    width: 450px;
}
tbody td:first-child {
    background:#fcfcfc;
    min-height:100px;
    height:202px;
    border-bottom:1px solid black;
    width: 80px;
}
tbody td:first-child a {
    font-size: 21px;
}
tbody td.td-marcado {
  -webkit-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75) !important;
-moz-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75) !important;
box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75) !important;
}
tbody tr:nth-child(2n-1) td:first-child {
    background: #efefef;
}
td{
    text-align:center;
    border:0.5px solid #ccc;
}
.impar td:nth-child(2n-1) {
    background: #eee;
}
.par td:nth-child(2n) {
    background: #eee;
}
.cheio {
  background: #ea8e8e !important;
}
.quase-cheio{
    background: #ffd78e !important;
}
.disponivel{
    background: #9dd49d !important;
}
.btn-exclusao {
position: absolute;
    top: -4px;
    color: red;
    float: right;
    right: 0px;
    font-size: 18px;
}
ul.list-group{
-webkit-box-shadow: 5px 5px 16px 0px rgba(82,82,82,1);
-moz-box-shadow: 5px 5px 16px 0px rgba(82,82,82,1);
box-shadow: 5px 5px 16px 0px rgba(82,82,82,1);
}
.atualizacaoAutomatica {
  position: fixed;
  bottom: 0;
  right: 0;
  padding: 10px;
  font-size: 15px;
  opacity: 0.8;
}
.strongBloqueado{
    /* border: 3px dashed #c10000;  */
    color:#d9534f;
    display: inline-block;
    padding: 10px;
    margin-top: 20px;
    font-size: 15px;
    /* transform: rotate(-16deg); */
    margin-bottom: 20px;
    letter-spacing: 2px;
}
</style>



// WEBPACK FOOTER //
// Agenda.vue?59e6ad5c